import AboutPageSection from "../../Components/AboutSections/AboutPageSection";
import PageBanner from "../../layout/Banner";
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";
import { Helmet } from "react-helmet-async";

const AboutPage = () => {
  return (
    <>
      <Helmet>
        <title>About - SKS Law Groups & Associates | Legal Experts Delhi </title>
        <meta
          name="description"
          content="Learn about SKS Law Groups & Associates, a trusted law firm offering expert legal services in intellectual property, patents, trademarks, and litigation."
        />
        <meta
          name="keywords"
          content="Adv. Shailendra Kumar Singh, Criminal Lawyer, Law Firm, About Us, Legal Experts, Attorneys, Legal Services, Justice"
        />
        <link rel="canonical" href="https://skslawgroupsandassociates.com/about-us" />
        <noscript>
          Please enable JavaScript to view this page properly.
        </noscript>
      </Helmet>
      <Header />
      <PageBanner title="About Us" subtitle="Get to know us" />
      <AboutPageSection />
      <Footer />
    </>
  );
};

export default AboutPage;
